export const isNullOrWhiteSpace = (value) => {
    let result = false;
    if (value === null || value === "" || value === undefined) {
        result = true;
    }
    return result;
}